<template lang="html">
  <section class="slider-productos" :active="actived" @mouseover="actived = true">
    <slick ref="slick" :options="slickOptions" @beforeChange="handleBeforeChange" class="slider-productos">
      <template v-for="(producto, key) in Object.values($t('slider_productos'))">
        <article class="slide" :el="key">
          <div class="texto container column-start">
            <h2 class="title -xs">{{ producto.titulo }}</h2>

            <p>{{ producto.cuerpo }}</p>

            <router-link :to="$t('enlaces.productos') + '/' + producto.slug" class="btn">
              <span>{{ $t("saber_mas") }}</span>
            </router-link>
          </div>
        </article>
      </template>
    </slick>

    <nav class="slider-menu container row-start">
      <template v-for="(producto, key) in Object.values($t('slider_productos'))">
        <a :active="key == active" @click="goTo(key)">{{ producto.button }}</a>
      </template>
      <div class="certificados">
        <div>
          <img src="/static/img/IFS-logo.png" alt="" />
          <a v-if="lang == 'es'" class="link-certificados" href="/static/pdf/certificado-IFS-es.pdf" download>{{ $t("certificadoIFS") }}</a>
          <a v-else class="link-certificados" href="/static/pdf/certificado-IFS.pdf" download>{{ $t("certificadoIFS") }}</a>
        </div>
        <div>
          <a  v-if="lang == 'es'" class="link-certificados" href="/static/pdf/certificado-BRC-es.pdf" download>{{ $t("certificadoBRC") }}</a>
          <a v-else class="link-certificados" href="/static/pdf/certificado-BRC.pdf" download>{{ $t("certificadoBRC") }}</a>
        </div>
      </div>
    </nav>

    <!--     <div class="contenedor-background">
      <parallax-container>
        <template v-for="(producto, key) in Object.values($t('slider_productos'))">
          <parallax-element :parallaxStrength="10" :type="'depth'" :show="key == active" class="parallax-el">
            <span :data="key" :show="key == active"></span>
          </parallax-element>
        </template>
      </parallax-container>
    </div>
 -->
  </section>
</template>

<script lang="js">

import Slick from 'vue-slick';
import { mapGetters } from 'vuex';

import Vue from 'vue'
import VueMouseParallax from 'vue-mouse-parallax'

Vue.use(VueMouseParallax)


export default {
  name: 'slider-productos',
  components: { Slick },
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
      },
      active: 0,
      actived: false
    }
  },
  methods: {
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      this.active = nextSlide;
    },
    goTo(id) {
      console.log(id);
      this.$refs.slick.goTo(id);
    },
  },
  computed: {
    ...mapGetters({
      lang: 'getLanguage'

    })
  }
}
</script>

<style scoped lang="scss">
$height: 870px;

.slider-productos {
  height: $height;
  width: 100%;
  display: inline-block;
  position: relative;
  transition: 0.8s;
  overflow: hidden;
}

.slide {
  display: inline-block;
  width: 100%;
  height: $height;

}

.slide[el="0"] {
  background: url(/static/img/slide-vino.jpg) center right/auto 100% no-repeat;

}

.slide[el="1"] {
  background: url(/static/img/slide-aceite.jpg) center right/auto 100% no-repeat;
}

.slide[el="2"] {
  background: url(/static/img/slide-azafran.jpg) center right/auto 100% no-repeat;
}

.slide[el="3"] {
  background: url(/static/img/slide-cava.jpg) center right/auto 100% no-repeat;
}

.slide[el="4"] {
  background: url(/static/img/slide-queso.jpg) center right/auto 100% no-repeat;
}


.slide .texto {
  width: 100%;
  height: $height;

  >* {
    opacity: 0;
    transform: translateX(300px);
    transition-duration: 1s;
  }

  p {
    margin-bottom: 20px;
    max-width: 400px;
    text-align: justify;
  }
}

@media screen and (max-width: 1250px) {
  .slide[el="4"] {
    background-position: calc(100% + 200px) center;
    background-size: 1200px auto;
  }
}

@media screen and (max-width: 1000px) {
  .slide[el="4"] {
    background-position: calc(100% + 200px) center;
    background-size: 1000px auto;
  }
}

@media screen and (max-width: 900px) {
  .slide[el="4"] {
    background-position: calc(100% + 200px) center;
    background-size: 800px auto;
  }
}

@media screen and (max-width: 750px) {
  .slide[el="4"] {
    background-position: calc(100% + 180px) center;
    background-size: 700px auto;
  }

}



@media screen and (max-width: 1250px) {
  .slide[el="3"] {
    background-position: calc(100% + 200px) center;
    background-size: 1300px auto;
  }
}

@media screen and (max-width: 1000px) {
  .slide[el="3"] {
    background-position: calc(100% + 200px) center;
    background-size: 1300px auto;
  }
}

@media screen and (max-width: 900px) {
  .slide[el="3"] {
    background-position: calc(100% + 200px) center;
    background-size: 900px auto;
  }
}

@media screen and (max-width: 750px) {
  .slide[el="3"] {
    background-position: calc(100% + 180px) center;
    background-size: 800px auto;
  }

}



@media screen and (max-width: 1250px) {
  .slide[el="2"] {
    background-position: calc(100% + 200px) center;
    background-size: 1400px auto;
  }
}

@media screen and (max-width: 1000px) {
  .slide[el="2"] {
    background-position: calc(100% + 200px) center;
    background-size: 1200px auto;
  }
}

@media screen and (max-width: 900px) {
  .slide[el="2"] {
    background-position: calc(100% + 200px) center;
    background-size: 1000px auto;
  }
}

@media screen and (max-width: 750px) {
  .slide[el="2"] {
    background-position: calc(100% + 180px) center;
    background-size: 800px auto;
  }

}

@media screen and (max-width: 1250px) {
  .slide[el="1"] {
    background-position: calc(100% + 200px) center;
    background-size: 1400px auto;
  }
}

@media screen and (max-width: 1000px) {
  .slide[el="1"] {
    background-position: calc(100% + 200px) center;
    background-size: 1200px auto;
  }
}

@media screen and (max-width: 900px) {
  .slide[el="1"] {
    background-position: calc(100% + 200px) center;
    background-size: 1000px auto;
  }
}

@media screen and (max-width: 750px) {
  .slide[el="1"] {
    background-position: calc(100% + 180px) center;
    background-size: 800px auto;
  }

}



@media screen and (max-width: 1250px) {
  .slide[el="0"] {
    background-position: calc(100% + 200px) center;
    background-size: 1400px auto;
  }
}

@media screen and (max-width: 1000px) {
  .slide[el="0"] {
    background-position: calc(100% + 200px) center;
    background-size: 1200px auto;
  }
}

@media screen and (max-width: 900px) {
  .slide[el="0"] {
    background-position: calc(100% + 200px) center;
    background-size: 1000px auto;
  }
}

@media screen and (max-width: 850px) {
  .slide[el="0"] {
    background-position: calc(100% + 180px) center;
    background-size: 700px auto;
  }

}

@media screen and (max-width: 750px) {
  .slide[el="0"] {
    background-position: calc(100% + 180px) center;
    background-size: 650px auto;
  }

}


@for $i from 1 through 5 {
  .slide .texto>*:nth-child(#{$i}) {
    transition-delay: #{$i / 3 + 1.3}s;
  }
}

@for $i from 1 through 5 {
  [active="true"] .slide .texto>*:nth-child(#{$i}) {
    transition-delay: #{$i / 3 + 0.2}s;
  }
}

.launched .slick-current .texto>* {
  opacity: 1;
  transform: translateY(0);
  /*  transition-delay: 0s;*/
}

[data="0"] {
  background: url("/static/img/vino-demo.jpg") center right/auto 100% no-repeat;
}

[data="1"] {
  background: url("/static/img/vino-demo-1.jpg") center right/auto 100% no-repeat;
}

[data="2"] {
  background: url("/static/img/vino-demo-2.jpg") center right/auto 100% no-repeat;
}

[data="3"] {
  background: url("/static/img/vino-demo-3.jpg") center right/auto 100% no-repeat;
}

.slider-menu {
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(400px);
  bottom: 50px;
  z-index: 5;
  transition-duration: 2s;
  transition-delay: 2s;
}


.launched .slider-menu {
  transform: translateX(-50%) translateY(0px);
}

.slider-menu a {
  font-family: "Yeseva One", cursive;
  color: #ffffff;
  font-size: 20px;
  position: relative;
  letter-spacing: 5px;
  margin-right: 40px;
  opacity: 0.8;
  transition: 0.5s;

  &.link-certificados {
    font-size: 14px;
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
    border-bottom: 1px solid white;
    padding-bottom: 5px;

    &::before {
      display: none;
    }

    &:hover {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  &::before {
    width: calc(100% + 20px);
    content: "";
    display: inline-block;
    height: 1px;
    position: absolute;
    left: -10px;
    bottom: -5px;
    background: white;
    transition: 0.5s;
    opacity: 0;
  }

  &:hover {
    opacity: 1;
    transform: translateY(-10px);
  }

  &[active="true"] {
    opacity: 1;
    transform: translateY(-10px) scale(1.1);
  }

  &:hover::before,
  &[active="true"]::before {
    opacity: 1;
  }
}

.contenedor-background {
  background: black;
  position: relative;
  z-index: 3;
  width: 624px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0;
  transition: 0.7s;
  transition-delay: 1s;

  .parallax-el {
    width: 100%;
    height: $height;
    transition: 0.6s;
    z-index: 3;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }

  span {
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: $height;
  }

  .parallax-el[show="true"] {
    opacity: 1;
  }
}

.page.launched {
  .contenedor-background {
    opacity: 1;
  }
}

@media screen and (max-width: 1100px) {
  .slider-productos {
    height: 700px;
  }

  .contenedor-background {
    width: 50%;

    span {
      height: 700px;
    }
  }
}

@media screen and (max-width: 768px) {
  .contenedor-background {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .slider-productos {
    height: auto;
  }

  .slide {
    height: auto;
    padding-bottom: 150px;

    .texto {
      height: auto;
      padding-top: 230px;
      overflow: hidden;

      p {
        text-align: left;
        max-width: 300px;
      }
    }
  }

  .slider-menu {
    bottom: 30px;

    a {
      margin-right: 0px;
      width: auto;
      padding: 0 5px;
      flex-grow: 2;
      text-align: center;
      font-size: 16px;
      letter-spacing: 0px;
      margin-bottom: 5px;

      &::before {
        width: 40px;
        left: 50%;
        margin-left: -20px;
      }

      &[active="true"] {
        transform: none;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .slide {
    .texto {
      p {
        text-align: left;
        max-width: 250px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/slider-productos.vue